<mat-stepper  [orientation]="isHandset ? 'vertical' : 'horizontal'" #stepper>
  <!-- Step 1: General Information -->
  <mat-step [stepControl]="generalInfoFormGroup">
    <ng-template matStepLabel>I. Opći podaci o prijavitelju programa/projekta</ng-template>
    @if (stepper.selectedIndex === 0) {
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">I. Opći podaci o prijavitelju programa/projekta</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="generalInfoFormGroup">
            @for (field of [
              { control: 'organizationName', label: 'Naziv organizacije', placeholder: 'Naziv organizacije', type: 'text' },
              { control: 'address', label: 'Adresa (ulica i broj)', placeholder: 'Adresa (ulica i broj)', type: 'text' },
              { control: 'postalCodeAndHeadquarters', label: 'Poštanski broj i sjedište', placeholder: 'Poštanski broj i sjedište', type: 'text' },
              { control: 'county', label: 'Županija', placeholder: 'Županija', type: 'text' },
              { control: 'authorizedRepresentative', label: 'Ime i prezime osobe ovlaštene za zastupanje', placeholder: 'Ime i prezime osobe ovlaštene za zastupanje', type: 'text' },
              { control: 'authorizedRepresentativeEmail', label: 'Adresa e-pošte osobe ovlaštene za zastupanje', placeholder: 'Adresa e-pošte osobe ovlaštene za zastupanje', type: 'text' },
              { control: 'authorizedRepresentativeRole', label: 'Dužnost osobe ovlaštene za zastupanje', placeholder: 'Dužnost osobe ovlaštene za zastupanje', type: 'text' },
              { control: 'telephone', label: 'Telefon', placeholder: 'Telefon', type: 'text' },
              { control: 'mobilePhone', label: 'Mobitel', placeholder: 'Mobitel', type: 'text' },
              { control: 'fax', label: 'Telefaks', placeholder: 'Telefaks', type: 'text' },
              { control: 'organizationEmail', label: 'Adresa e-pošte', placeholder: 'Adresa e-pošte', type: 'text' },
              { control: 'website', label: 'Internetska stranica', placeholder: 'Internetska stranica', type: 'text' },
              { control: 'yearOfEstablishment', label: 'Godina osnutka', placeholder: 'Godina osnutka', type: 'number', config: { decimals: 0, useThousands: false, maxDigits: 4 } },
              { control: 'dateOfRegistration', label: 'Datum i godina upisa u matični registar', placeholder: 'Datum i godina upisa u matični registar', type: 'date' },
              { control: 'registrationNumber', label: 'Registarski broj', placeholder: 'Registarski broj', type: 'text' },
              { control: 'registeredAuthority', label: 'Registrirana pri (naziv registracijskog tijela)', placeholder: 'Registrirana pri (naziv registracijskog tijela)', type: 'text' },
              { control: 'bankName', label: 'Naziv banke', placeholder: 'Naziv banke', type: 'text' },
              { control: 'bankAccountNumber', label: 'Broj žiro-računa (IBAN)', placeholder: 'Broj žiro-računa (IBAN)', type: 'text' },
              { control: 'oib', label: 'OIB', placeholder: 'OIB', type: 'text' },
              { control: 'rno', label: 'RNO', placeholder: 'RNO', type: 'text' },
              { control: 'objectivesAccordingToStatute', label: 'Ciljevi osnivanja sukladno Statutu', placeholder: 'Ciljevi osnivanja sukladno Statutu', type: 'text' },
              { control: 'purposeAndFieldOfOperation', label: 'Svrha i područje djelovanja', placeholder: 'Svrha i područje djelovanja', type: 'text' },
              { control: 'activitiesAccordingToStatute', label: 'Djelatnost(i) organizacije sukladno Statutu', placeholder: 'Djelatnost(i) organizacije sukladno Statutu', type: 'text' },
              { control: 'totalMembers', label: 'Ukupan broj članova', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
              { control: 'totalIndividualMembers', label: 'Ukupan broj građana', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
              { control: 'totalLegalEntities', label: 'Ukupan broj pravnih osoba', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
              { control: 'volunteerWorkShare', label: 'Udio volonterskog rada u organizaciji (upišite postotak)', placeholder: 'Udio volonterskog rada u organizaciji (upišite postotak)', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 3 } },
              { control: 'numberOfVolunteers', label: 'Broj osoba koje volontiraju', placeholder: 'Broj osoba koje volontiraju', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
              { control: 'volunteerHoursInPreviousYear', label: 'Broj sati volonterskog rada ostvarenih u prethodnoj godini', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
              { control: 'temporaryEmployees', label: 'Broj zaposlenih na određeno u prethodnoj godini', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
              { control: 'permanentEmployees', label: 'Broj zaposlenih na neodređeno u prethodnoj godini', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
              { control: 'isInVATSystem', label: 'Je li organizacija u sustavu PDV-a', type: 'checkbox' },
              { control: 'totalIncomeInPreviousYear', label: 'Ukupno ostvareni prihodi u prethodnoj godini', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
              { control: 'incomeFromGovernmentDonationsInPreviousYear', label: 'Prihodi ostvareni od donacija državnog proračuna u prethodnoj godini', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
              { control: 'incomeFromLocalAndRegionalAuthoritiesInPreviousYear', label: 'Prihodi ostvareni od donacija iz proračuna jedinica lokane i područne (regionalne) samouprave u prethodnoj godini', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
              { control: 'incomeFromInternationalOrganizationsInPreviousYear', label: 'Prihodi ostvareni od inozemnih vlada i međunarodnih organizacija u prethodnoj godini', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
              { control: 'incomeFromBusinessesAndLegalEntitiesInPreviousYear', label: 'Prihodi ostvareni od trgovačkih društava i ostalih pravnih osoba u prethodnoj godini', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
              { control: 'incomeFromIndividualsInPreviousYear', label: 'Prihodi ostvareni od građana i kućanstava u prethodnoj godini', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
              { control: 'incomeFromNonprofitOrganizationsInPreviousYear', label: 'Prihodi ostvareni od povezanih neprofitnih organizacija u prethodnoj godini', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
              { control: 'membershipFeesInPreviousYear', label: 'Prihodi ostvareni od prihoda od članarine u prethodnoj godini', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
              { control: 'euFundsInPreviousYear', label: 'Prihodi ostvareni iz EU fondova u prethodnoj godini', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
              { control: 'totalSalaryPaidInPreviousYear', label: 'Ukupan iznos isplaćen za plaće u prethodnoj godini', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
              { control: 'totalCompensationPaidInPreviousYear', label: 'Ukupan iznos isplaćen za naknade drugog dohotka u prethodnoj godini', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
              { control: 'ownSpaceSize', label: 'Vlastiti prostor (upisati veličinu u kvadratnim metrima)', type: 'number', config: { decimals: 1, useThousands: false, maxDigits: 10 } },
              { control: 'rentedSpaceSize', label: 'Iznajmljeni prostor (upisati veličinu u kvadratnim metrima)', type: 'number', config: { decimals: 1, useThousands: false, maxDigits: 10 } },
              { control: 'municipalSpaceSize', label: 'prostor općine/grada/županije/RH (upisati veličinu u kvadratnim metrima)', type: 'number', config: { decimals: 1, useThousands: false, maxDigits: 10 } },
              { control: 'monthlyRentForMunicipalSpace', label: 'Iznos mjesečnog najama za prostor općine/grada/županije/RH', type: 'number', config: { decimals: 2, useThousands: false, maxDigits: 10 } },
              { control: 'totalApprovedGrantsInPreviousYear', label: 'Broj ukupno odobrenih bespovratnih potpora u prethodnoj godini', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
              { control: 'numberOfPartnerships', label: 'Broj partnerstva u koja je organizacija uključena na provedbi programa/projekta u trenutku prijave na ovaj natječaj', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
              { control: 'isAnnualReportPrepared', label: 'Izrađujete li godišnji izvještaj o radu?', type: 'checkbox' },
              { control: 'reportRecipients', label: 'Ukoliko ste označili odgovor “da”, kome ga dostavljate i na koji način ga predstavljate javnosti?', type: 'text' },
              { control: 'implementsQualitySystem', label: 'Provodite li neki od sustava kvalitete za neprofitne organizacije?', type: 'checkbox' },
              { control: 'qualitySystemDetails', label: 'Ukoliko ste označili odgovor da, koji sustav i od kada?', placeholder: 'Ukoliko ste označili odgovor da, koji sustav i od kada?', type: 'text' }
              ]; track field) {
              <div>
                <div class="mb-25">
                  @if (field.type === 'text') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <textarea matInput [formControlName]="field.control"></textarea>
                    </mat-form-field>
                  }
                  @if (field.type === 'number') {
                    <mat-form-field class="full-width">
                      <mat-label>{{ field.label }}</mat-label>
                      <input matInput formattedNumber
                        [config]="field.config"
                        [formControlName]="field.control" />
                      </mat-form-field>
                    }
                    @if (field.type === 'date') {
                      <mat-form-field class="full-width">
                        <mat-label>{{ field.label }}</mat-label>
                        <input matInput [matDatepicker]="picker" [formControlName]="field.control">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    }
                    @if (field.type === 'checkbox') {
                      <mat-checkbox [formControlName]="field.control">{{ field.label }}</mat-checkbox>
                    }
                    @if (field.type === 'select') {
                      <mat-form-field class="full-width">
                        <mat-label>{{ field.label }}</mat-label>
                        <mat-select [formControlName]="field.control">
                          @for (item of ($any(field).dataSource || []); track item) {
                            <mat-option [value]="item.value">
                              {{ item.label }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </div>
                </div>
              }
              <div>
                <button mat-flat-button matStepperNext class="daxa" [disabled]="generalInfoFormGroup.invalid">Dalje</button>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
      }
    </mat-step>

    <!-- Step 2: Program / Project Information -->
    <mat-step [stepControl]="programProjectFormGroup">
      <ng-template matStepLabel>II. Podaci o programu/projektu</ng-template>
      @if (stepper.selectedIndex === 1) {
        <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
          <mat-card-header>
            <mat-card-title>
              <h5 class="mb-0">II. Podaci o programu/projektu</h5>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <form [formGroup]="programProjectFormGroup">
              @for (field of [
                { label: 'Molimo označite prijavljujete li program, projekt ili manifestaciju', control: 'category', type: 'select', dataSource: [ { value: 1, label: 'Program' }, { value: 2, label: 'Projekt' }, { value: 3, label: 'Manifestacija' } ] },
                { label: 'Područje djelovanja na koje se program/projekt odnosi', control: 'area', type: 'select', dataSource: [ { value: 1, label: 'I. Sport i rekreacija' }, { value: 2, label: 'II. Kultura' }, { value: 3, label: 'III. Ostale društvene djelatnosti' } ] },
                { label: 'Naziv programa/projekta', control: 'programProjectName', type: 'text' },
                { label: 'Sažetak programa/projekta', control: 'summary', type: 'text' },
                { label: 'Predviđeno trajanje provedbe u mjesecima', control: 'expectedDurationMonths', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
                { label: 'Zemljopisno područje provedbe (mjesto, grad, općina, županija, država)', control: 'geographicalArea', type: 'text' },
                { label: 'Ukupan iznos potreban za provedbu', control: 'totalAmountRequired', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
                { label: 'Iznos koji se traži od Općine (do 100% ukupne vrijednosti programa/projekta)', control: 'amountRequestedFromMunicipality', type: 'number', config: { decimals: 2, useThousands: true, maxDigits: 10 } },
                { label: 'Ako je iznos ukupnih troškova za provedbu programa/projekta veći od iznosa koji se može dobiti od Općine Donji Andrijevci, molimo navedite kako ćete osigurati ostatak sredstava za provedbu akcije', control: 'additionalFundingSources', type: 'text' },
                { label: 'Opišite što Vas je potaknulo da prijavite ovaj program/projekt, odnosno kako ste utvrdili potrebe i koji problem rješavate ovim programom/projektom', control: 'motivationDescription', type: 'text' },
                { label: 'Navedite i opišite ciljeve koji se namjeravaju ostvariti provedbom predloženog programa/projekta', control: 'projectGoals', type: 'text' },
                { label: 'Opišite mjerljive rezultate koje očekujete po završetku provođenja vašeg programa/projekta', control: 'expectedResults', type: 'text' },
                { label: 'Objasnite na koji način i kojim sadržajima predloženi program/projekt doprinosi ostvarenju općeg i posebnih ciljeva utvrđenih pozivom ili natječajem', control: 'contributionToGoals', type: 'text' },
                { label: 'Tko su ciljane skupine (skupine na koje aktivnosti izravno utječu) obuhvaćene projektom, njihov broj i struktura?', control: 'targetGroups', type: 'text' },
                { label: 'Tko su krajnji korisnici (pojedinci, skupine, organizacije koje nisu izravno uključene u provedbu, ali provedba na njih ima posredan utjecaj)? Na koji način će na njih utjecati?', control: 'endUsersImpact', type: 'text' },
                { label: 'Voditeljica / voditelj programa/projekta (upišite ime i prezime i priložite životopis na propisanom obrascu ukoliko je životopis kao prilog obvezan sukladno Uputama za prijavitelje)', control: 'projectLeader', type: 'text' },
                { label: 'Broj volontera koji sudjeluju u provedbi programa/projekta (navedite broj volontera, broj predviđenih volonterskih sati i zaduženja)', control: 'numberOfVolunteersInvolved', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
                { label: 'Broj zaposlenih osoba koje sudjeluju u provedbi programa/projekta', control: 'numberOfEmployeesInvolved', type: 'number', config: { decimals: 0, useThousands: true, maxDigits: 10 } },
                { label: 'Jeste li do sada imali iskustva u organiziranju i provedbi sličnih programa/projekata? Ako jeste, molimo da to ovdje kratko opišete', control: 'similarExperience', type: 'text' }
                ]; track field) {
                <div>
                  <div class="mb-25">
                    @if (field.type === 'text') {
                      <mat-form-field class="full-width">
                        <mat-label>{{ field.label }}</mat-label>
                        <textarea matInput [formControlName]="field.control"></textarea>
                      </mat-form-field>
                    }
                    @if (field.type === 'number') {
                      <mat-form-field class="full-width">
                        <mat-label>{{ field.label }}</mat-label>
                        <input matInput formattedNumber [config]="field.config" [formControlName]="field.control" />
                      </mat-form-field>
                    }
                    @if (field.type === 'date') {
                      <mat-form-field class="full-width">
                        <mat-label>{{ field.label }}</mat-label>
                        <input matInput [matDatepicker]="picker" [formControlName]="field.control">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    }
                    @if (field.type === 'checkbox') {
                      <mat-checkbox [formControlName]="field.control">{{ field.label }}</mat-checkbox>
                    }
                    @if (field.type === 'select') {
                      <mat-form-field class="full-width">
                        <mat-label>{{ field.label }}</mat-label>
                        <mat-select [formControlName]="field.control">
                          @for (item of ($any(field).dataSource || []); track item) {
                            <mat-option [value]="item.value">
                              {{ item.label }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </div>
                </div>
              }
              <div>
                <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
                <button mat-flat-button matStepperNext class="daxa" [disabled]="programProjectFormGroup.invalid">Dalje</button>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
      }
    </mat-step>

    <!-- Step 3: Visibility Information -->
    <mat-step [stepControl]="visibilityFormGroup">
      <ng-template matStepLabel>III. Vidljivost programa/projekta</ng-template>
      @if (stepper.selectedIndex === 2) {
        <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
          <mat-card-header>
            <mat-card-title>
              <h5 class="mb-0">III. Vidljivost programa/projekta</h5>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <form [formGroup]="visibilityFormGroup">
              <mat-form-field class="mb-25">
                <mat-label>Opišite na koji način planirate uključiti stanovnike Općine u aktivnosti programa/projekta te informirati širu javnost o tijeku provedbe i rezultatima programa/projekta</mat-label>
                <textarea matInput formControlName="publicEngagementPlan"></textarea>
              </mat-form-field>
              <div>
                <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
                <button mat-flat-button matStepperNext class="daxa" [disabled]="visibilityFormGroup.invalid">Dalje</button>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
      }
    </mat-step>

    <!-- Step 4: Application activities -->
    <mat-step [stepControl]="activitiesFormGroup">
      <ng-template matStepLabel>IV. Aktivnosti</ng-template>
      @if (stepper.selectedIndex === 3) {
        @if (!isLoading) {
          <app-activities
            [activitiesForm]="activitiesFormGroup">
          </app-activities>
        }
        <div>
          <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
          <button mat-flat-button matStepperNext class="daxa" [disabled]="activitiesFormGroup.invalid">Dalje</button>
        </div>
      }
    </mat-step>

    <!-- Step 5: Budget Plan -->
    <mat-step [stepControl]="budgetPlanFormGroup">
      <ng-template matStepLabel>V. Proračun</ng-template>
      @if (stepper.selectedIndex === 4) {
        <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
          <mat-card-header>
            <mat-card-title>
              <h5 class="mb-0">V. Proračun</h5>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            @if (!isLoading) {
              <app-budget-plan
                [budgetPlanForm]="budgetPlanFormGroup">
              </app-budget-plan>
            }
            <div class="actions">
              <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
              <button mat-flat-button matStepperNext class="daxa" [disabled]="budgetPlanFormGroup.invalid">Dalje</button>
            </div>
          </mat-card-content>
        </mat-card>
      }
    </mat-step>

    <!-- Step 6: Documents -->
    <mat-step [stepControl]="attachmentsFormGroup">
      <ng-template matStepLabel>VI. Dokumenti</ng-template>
      @if (stepper.selectedIndex === 5) {
        <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
          <mat-card-header>
            <mat-card-title>
              <h5 class="mb-0">VI. Dokumenti</h5>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p class="mb-10">
              <strong>Molimo Vas priložite sljedeće dokumente:</strong>
            </p>
            <ul>
              <li><strong>Potvrdu o nekažnjavanju ne stariju od šest mjeseci</strong></li>
              <li><strong>Potpisanu i pečatom ovjerenu izjavu o nepostojanju dvostrukog financiranja</strong></li>
              <li><strong>Potvrdu porezne uprave o nepostojanju duga</strong></li>
              <li><strong>Ostale relevantne dokumente</strong></li>
            </ul>
            @if (!isLoading) {
              <app-file-upload
                [storageLocation]="attachmentsFormGroup.get('fileStorageLocation')?.value">
              </app-file-upload>
            }
            <br/>
          </mat-card-content>
          <div class="actions px-2 pb-2">
            <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
            <button mat-flat-button matStepperNext class="daxa">Dalje</button>
          </div>
        </mat-card>
      }
    </mat-step>

    <!-- Step 7: Review and Submit -->
    <mat-step>
      <ng-template matStepLabel>Završetak</ng-template>
      @if (stepper.selectedIndex === 6) {
        <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
          <mat-card-header>
            <mat-card-title>
              <h5 class="mb-0">Čestitamo, stigli ste do samoga završetka!
              Pritiskom na gumb, Vaša prijava bit će spremljena kao skica. Sve dok je prijava u statusu skice, možete je slobodno uređivati i prilagođavati.</h5>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div>
              <button mat-flat-button class="mr-15" matStepperPrevious>Nazad</button>
              <button mat-flat-button color="primary" (click)="onSubmit(stepper)">Spremite</button>
            </div>
          </mat-card-content>
        </mat-card>
      }
    </mat-step>
  </mat-stepper>


  <!-- Sticky Save Button for Both Create and Edit Modes -->
  @if (!isLoading) {
    <div class="sticky-save-container">
      <button
        mat-fab
        color="primary"
        class="sticky-save-button"
        (click)="saveApplication()"
        [disabled]="isSaving"
        [matTooltip]="'Spremi promjene'">
        @if (!isSaving) {
          <mat-icon>save</mat-icon>
        }
        @if (isSaving) {
          <mat-icon class="spinning">hourglass_empty</mat-icon>
        }
      </button>
    </div>
  }
